import React, { useEffect } from "react";
import { useCrud } from "../common/crudCard/useCrud";
import { CrudLayout } from "../common/crudCard/crudLayout";
import { useHistory } from "react-router-dom";
import { getProyectos, checkDeleteProyecto, deleteProyecto } from "../../services/proyectosService";
import { cleanString } from "../utils/cleanString";
import ProyectosTable from "./proyectosTable";

export default function Proyectos(props) {
  const { onLoading, onDoneLoading } = props;

  const title = "Proyectos";

  const breadcrumbs = [
    {
      title: "Inicio",
      link: "/main",
    },
    {
      title: "Proyectos",
    },
  ];

  const history = useHistory();

  const filterData = (records, query) => {
    return records.filter(
      (m) =>
        cleanString(m.nombre).includes(cleanString(query)) ||
        cleanString(m.ubicacion).includes(cleanString(query)) ||
        m.socios.some(
          (socio) =>
            cleanString(socio.persona.apellido).includes(cleanString(query)) ||
            cleanString(socio.persona.nombre).includes(cleanString(query)),
        ),
    );
  };

  const checkBeforeDelete = async (id) => {
    const canDelete = await checkDeleteProyecto(id);
    return canDelete;
  };

  const onDelete = async (id) => {
    try {
      await deleteProyecto(id);
    } catch (ex) {
      throw ex;
    }
  };

  const crud = useCrud({
    defaultPath: "/proyectos",
    defaultSortColumn: { path: "ubicacion", order: "asc" },
    checkBeforeDelete,
    filterData,
    onDelete,
    onLoading,
    onDoneLoading,
  });

  const fetchData = async () => {
    onLoading();
    const registros = await getProyectos();
    onDoneLoading();
    if (registros === "NETWORK ERROR") return history.push("/noconnection");
    crud.updateAllRecords(registros);
  };

  const handleSearch = (query) => {
    crud.setSearchQuery(query);
    crud.setCurrentPage(1);
  };

  useEffect(() => {
    if (!crud.mounted) {
      fetchData();
      crud.setMounted(true);
    }
  }, []);

  return (
    <CrudLayout
      title={title}
      breadcrumbs={breadcrumbs}
      newLink="/proyectos/nuevo"
      permisos={crud.permisos}
      onChangeSearch={handleSearch}
      onPageChange={crud.handlePageChange}
      filterData={filterData}
      totalCount={crud.totalCount}
      pageSize={crud.pageSize}
      currentPage={crud.currentPage}
    >
      <ProyectosTable
        permisos={crud.permisos}
        records={crud.records}
        onDelete={(id) => crud.handleDelete(id)}
        onEdit={(id) => crud.handleEdit(id)}
        onSort={(sortColumn) => crud.handleSort(sortColumn)}
        onView={(id) => crud.handleView(id)}
        sortColumn={crud.sortColumn}
      />
    </CrudLayout>
  );
}
